
import React from 'react';
import Main1Component from './main1';
import Main2Component from './main2';
import {Route,Switch,Redirect} from 'react-router-dom'
import "./mainContent.css"
import Main3Component from './main3';
import Main4Component from './main4';
import Main5Component from './main5';

export default class MainContent extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="col-12 col-md-9 col-xl-7  offset-md-3 m-content" >
               <Switch>
               <Route path="/getting-start" exact  component={Main1Component}/>
                <Route path="/example" 
                render={(props)=><Main2Component
                    showMenu={this.props.showMenu} 
                    deleteMenu={this.props.deleteMenu}>
                ></Main2Component>}/>
                
                <Route path="/api" component={Main3Component}/>
                
                <Route path="/themes" component={Main4Component}/>
                
                <Route path="/options" component={Main5Component}/>
                <Route render={() => <Redirect to="/getting-start" />} />               
                </Switch>
            </div>
        )
    }

}